import React, { Component } from 'react';
import { MDBProgress } from 'mdbreact';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import FadeIn from 'react-fade-in';
import Slider from 'react-slick';
import CountUp from 'react-countup';
import Header from '../layout/Header';

export class Aboutus_01 extends Component {
    render() {
        var slick_slider = {
          dots: false,
          arrow: false,
          autoplay: true,
          infinite: true,
          speed: 500,
          slidesToShow: 4,
          slidesToScroll: 1,

          responsive: [{

            breakpoint: 1199,
            settings: {
            slidesToShow: 3,
            slidesToScroll: 3
            }
        },
        {
      
            breakpoint: 1024,
            settings: {
            slidesToShow: 3,
            slidesToScroll: 3
            }
        },
        {
      
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
        };
        return (
            <div className="site-main">
                <Header />
                {/* page-title */}
                <div className="ttm-page-title-row">
                    <div className="container-xl">
                        <div className="row">
                            <div className="col-md-12"> 
                                <div className="title-box">
                                    <div className="page-title-heading">
                                        <h1 className="title">About Us</h1>
                                    </div>{/* /.page-title-captions */}
                                    <div className="breadcrumb-wrapper">
                                    <span>
                                        <a title="Homepage" href={process.env.PUBLIC_URL + '/'} >&nbsp;&nbsp;Home</a>
                                    </span>
                                    <span className="ttm-bread-sep">&nbsp; : : &nbsp;</span>
                                    <span>About Us 01</span>
                                    </div>  
                                </div>
                            </div>{/* /.col-md-12 */}  
                        </div>{/* /.row */}  
                    </div>{/* /.container */}                      
                </div>
                {/* page-title end*/}
                <section class="ttm-row about-us-section clearfix">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-6">
                                <div class="ttm_single_image-wrapper">
                                    <img className="img-fluid" src="./images/single-img-1.png" />
                                </div>
                            </div>
                            <div class="col-xl-6 align-self-center">
                                <div class="position-relative">
                                    <div class="section-title">
                                        <div class="title-header">
                                        <h2 className='title'>Giving your business some orignal ideas</h2>
                                        </div>
                                        <div class="title-desc">
                                        <p class="res-991-pb-0">Web designing in a powerful way of just not a profession, however in a passion for our Company. We have a tendency to believe the idea that smart looking.</p>
                                        </div>
                                    </div>
                                    <div class="row row-equal-height mt-10">
                                        <div class="col-lg-6">
                                            <div class="featured-box-main">
                                            <h3 class="featured-box-h3">Design first career page builder.</h3>
                                            <div class="ttm-horizontal_sep mt-30 mb-30 border-none res-991-mb-15 res-991-d-none res-991-mt-15"></div>
                                            <h3 class="featured-box-h3">Experience to share goals success</h3>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="featured-box-main">
                                                <h3 class="featured-box-h3">Comprehensive test approach</h3>
                                                <div class="ttm-horizontal_sep mt-30 mb-30 border-none res-991-mb-15 res-991-d-none res-991-mt-15"></div>
                                                <h3 class="featured-box-h3">Innovate create great solutions.</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="ttm-row padding_top_zero-section ttm-bg bg-base-grey clearfix">
                    <div class="container">
                        <div class="row">                
                            <div class="col-xl-6 col-lg-6">
                                <div class="position-relative">
                                    <div class="section-title">
                                        <div class="title-header mb-0">
                                            <h2 className='title'>Awards & achievements</h2>
                                        </div>
                                        <div class="title-desc">
                                            <p>Web designing in a powerful way of just not a profession, however in a passion for our Company. We have a tendency to believe.</p>
                                        </div>
                                    </div>
                                    <div class="ttm-box-col-wrapper-style1">
                                        <div class="ttm-history-box-content">
                                            <div class="ttm-history-box-border"></div>
                                            <div class="ttm-history-box-title">
                                                <h3 class="ttm-history-box-h3">2019 Site of the day</h3>
                                                <p>Well aware of the existing mobile app market trends to keep tabs on the evolving trend of the industry.</p>
                                            </div>
                                        </div>
                                        <div class="ttm-history-box-content">
                                            <div class="ttm-history-box-border"></div>
                                            <div class="ttm-history-box-title">
                                                <h3 class="ttm-history-box-h3">2020 Site of the month</h3>
                                                <p>Well aware of the existing mobile app market trends to keep tabs on the evolving trend of the industry.</p>
                                            </div>
                                        </div>
                                        <div class="ttm-history-box-content">
                                            <div class="ttm-history-box-border"></div>
                                            <div class="ttm-history-box-title">
                                                <h3 class="ttm-history-box-h3">2021 Site of the year</h3>
                                                <p class="paragraph-8">Well aware of the existing mobile app market trends to keep tabs on the evolving trend of the industry.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6">
                                <div class="ttm_single_image-wrapper res-991-pt-30">
                                    <img className="img-fluid" src="./images/single-img-2.png" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="ttm-row bg-img2 ttm-bgimage-yes ttm-bg bg-base-dark testimonial-section clearfix">
                    <div class="ttm-row-wrapper-bg-layer ttm-bg-layer bg-base-dark"></div>
                        <div class="container-fluid">
                            <div class="row align-items-center spacing-2">
                            <div class="col-lg-3">
                                <div class="pr-20 res-1199-pr-0">
                                    <div class="ttm-custom-counter-content">
                                        <h3 class="ttm-custom-heading counter is-visible">15000+</h3>
                                        <h3 class="custom-heading-h3">Happy freelancers &amp; agencies</h3>
                                    </div>
                                    <div class="ttm-custom-counter-desc">
                                        <p class="counter-desc-p">Our satisfied customers have the best words for our templates</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-9 res-991-mt-20">
                                <Slider className="row slick_slider slick-arrows-style4" {...slick_slider} slidesToShow={3}arrows={false}
                                    autoplay={false} responsive= { [{ breakpoint: 1199, settings: {slidesToShow: 2,slidesToScroll: 2 }},
                                    {breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 }} ,
                                    {breakpoint: 767, settings: { slidesToShow: 1, slidesToScroll: 1 }}] }>
                                    <div className="col-lg-12">
                                    <div class="testimonials-style1">
                                        <div class="testimonials-style1-content">
                                            <div class="testimonial-ttm-description">
                                            <div class="ttm-box-highlight">
                                                <h3 class="ttm-box-highlight-h3">Fast Support</h3>
                                            </div>
                                            <div class="ttm-ratting-stars">
                                                <ul class="ratting-stars">
                                                <li class="ratting-stars-items">
                                                    <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                </li>
                                                <li class="ratting-stars-items">
                                                    <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                </li>
                                                <li class="ratting-stars-items">
                                                    <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                </li>
                                                <li class="ratting-stars-items">
                                                    <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                </li>
                                                <li class="ratting-stars-items">
                                                    <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                </li>
                                                </ul>
                                            </div>
                                            </div>
                                            <div class="testimonial-ttm-box-desc">
                                            <p class="testimonial-ttm-box-desc-p">Our team discussed every single detail to make sure Creatives Planet is
                                             the most versatile and unique template created so far. No coding skills.</p>
                                            </div>
                                            <div class="ttm-box-footer">
                                            <h3 class="testimonial-caption-h3">Leon Mayer</h3>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                    <div className="col-lg-12">
                                    <div class="testimonials-style1">
                                        <div class="testimonials-style1-content">
                                            <div class="testimonial-ttm-description">
                                            <div class="ttm-box-highlight">
                                                <h3 class="ttm-box-highlight-h3">Flexible Theme</h3>
                                            </div>
                                            <div class="ttm-ratting-stars">
                                                <ul class="ratting-stars">
                                                <li class="ratting-stars-items">
                                                    <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                </li>
                                                <li class="ratting-stars-items">
                                                    <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                </li>
                                                <li class="ratting-stars-items">
                                                    <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                </li>
                                                <li class="ratting-stars-items">
                                                    <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                </li>
                                                <li class="ratting-stars-items">
                                                    <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                </li>
                                                </ul>
                                            </div>
                                            </div>
                                            <div class="testimonial-ttm-box-desc">
                                                <p class="testimonial-ttm-box-desc-p">Excepteur sint occaecat cupidatat non proident, sunt in culpa qui 
                                                officia deserunt mollit anim laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                                                accusantium doloremque laudantiumtam rem aperiam eaque ipsa quae inventore veritatis quasi architecto 
                                                beatae vitae.</p>
                                            </div>
                                            <div class="ttm-box-footer">
                                            <h3 class="testimonial-caption-h3">Aenna Bell</h3>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                    <div className="col-lg-12">
                                    <div class="testimonials-style1">
                                        <div class="testimonials-style1-content">
                                            <div class="testimonial-ttm-description">
                                            <div class="ttm-box-highlight">
                                                <h3 class="ttm-box-highlight-h3">Fast Support</h3>
                                            </div>
                                            <div class="ttm-ratting-stars">
                                                <ul class="ratting-stars">
                                                <li class="ratting-stars-items">
                                                    <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                </li>
                                                <li class="ratting-stars-items">
                                                    <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                </li>
                                                <li class="ratting-stars-items">
                                                    <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                </li>
                                                <li class="ratting-stars-items">
                                                    <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                </li>
                                                <li class="ratting-stars-items">
                                                    <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                </li>
                                                </ul>
                                            </div>
                                            </div>
                                            <div class="testimonial-ttm-box-desc">
                                            <p class="testimonial-ttm-box-desc-p">Our team discussed every single detail to make sure Creatives Planet is
                                            the most versatile and unique template created so far. No coding skills.</p>
                                            </div>
                                            <div class="ttm-box-footer">
                                            <h3 class="testimonial-caption-h3">John Amanda</h3>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                    <div className="col-lg-12">
                                    <div class="testimonials-style1">
                                        <div class="testimonials-style1-content">
                                            <div class="testimonial-ttm-description">
                                            <div class="ttm-box-highlight">
                                                <h3 class="ttm-box-highlight-h3">Flexible Theme</h3>
                                            </div>
                                            <div class="ttm-ratting-stars">
                                                <ul class="ratting-stars">
                                                <li class="ratting-stars-items">
                                                    <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                </li>
                                                <li class="ratting-stars-items">
                                                    <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                </li>
                                                <li class="ratting-stars-items">
                                                    <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                </li>
                                                <li class="ratting-stars-items">
                                                    <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                </li>
                                                <li class="ratting-stars-items">
                                                    <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                                </li>
                                                </ul>
                                            </div>
                                            </div>
                                            <div class="testimonial-ttm-box-desc">
                                            <p class="testimonial-ttm-box-desc-p">Excepteur sint occaecat cupidatat non proident, sunt in culpa qui 
                                                officia deserunt mollit anim laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                                                accusantium doloremque laudantiumtam rem aperiam eaque ipsa quae inventore veritatis quasi architecto 
                                                beatae vitae.</p>
                                            </div>
                                            <div class="ttm-box-footer">
                                            <h3 class="testimonial-caption-h3">Aenna Bell</h3>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </Slider>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="ttm-row tab-section-2 clearfix">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-xl-8 col-lg-6 col-md-12 col-sm-12">
                                <div class="blog-title text-right">
                                    <div class="section-title style2">
                                        <div class="title-header">
                                            <h2>Stay up</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 "> 
                                <div class="process-desc process-desc1">
                                    <p class="desc-text">Web designing in a powerful way of just not a profession, how in a passion for our Company. We have a to the idea.</p>
                                </div>
                            </div>
                        </div>
                        <div class="row align-items-center mt-25 res-991-mt-0">
                            <div class="col-xl-4 col-lg-3 col-md-12 col-sm-12 blog-sm">
                                <div class="blog-title text-right">
                                    <a class="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-fill ttm-btn-color-gradiant res-991-mb-30" href="blog.html">Upcoming News!</a>
                                </div>
                            </div>
                            <div class="col-xl-8 col-lg-9 col-md-12 col-sm-12 "> 
                                <div class="section-title style2">
                                    <div class="title-header">
                                    <h2>to date</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                        <div className="col-lg-12">
                            <div className="ttm-tabs text-center ttm-tab-style-classic style1">
                            <Tabs defaultIndex={2} onSelect={index => console.log(index)}>{/* tabs */}
                            <TabList className="tabs">
                                <Tab className="tab"><span> Our goals</span></Tab>
                                <Tab className="tab"><span> Our vision</span></Tab>
                                <Tab className="tab"><span> Our history</span></Tab>
                            </TabList>
                            <div className="content-tab">
                                <FadeIn>
                                <TabPanel>
                                    <div className="content-inner">
                                        <div className="row">
                                            <div className="col-lg-6">
                                            <div className="res-991-pb-30">
                                                <img class="img-fluid" alt="tab-image" src="images/single-img-3.png" loading="lazy" />
                                            </div>
                                        </div>
                                        <div class="col-lg-6 align-self-center">
                                            <div class="tab-content-2 res-991-mt-20 res-767-mt-0">
                                                <h3 class="tab-content-h3">Our firm is an expert to creates</h3>
                                                <p>Well aware of the existing mobile app market trends to keep tabs on the evolving trend of the industry, to developing high-gradequality at the top positions! Web designing in a powerful way of just not a profession, hony. We have a tendency to beve.</p>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-6 col-md-6 col-sm-6">
                                                    <div class="list-border-left">
                                                        <ul class="tab-list">
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Marketing analysis</div>
                                                            </li>
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Superior Integration</div>
                                                            </li>
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Data visualization</div>
                                                            </li>
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Digital experiences</div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-6">
                                                    <div class="pl-20 res-1199-pl-0 res-575-pl-0">
                                                        <ul class="tab-list res-575-mt-0">
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Marketing analysis</div>
                                                            </li>
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Machine learning</div>
                                                            </li>
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Business intelligence</div>
                                                            </li>
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Team Performance</div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>{/* row end */}
                                    </div>{/* content-inner */}{/* row end*/}
                                </TabPanel>
                                <TabPanel>
                                <div className="content-inner">
                                    <div className="row">
                                    <div class="col-lg-6 align-self-center">
                                            <div class="tab-content-2 res-991-mt-20 res-767-mt-0">
                                                <h3 class="tab-content-h3">Our firm is an expert to creates</h3>
                                                <p>Well aware of the existing mobile app market trends to keep tabs on the evolving trend of the industry, to developing high-gradequality at the top positions! Web designing in a powerful way of just not a profession, hony. We have a tendency to beve.</p>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-6 col-md-6 col-sm-6">
                                                    <div class="list-border-left">
                                                        <ul class="tab-list">
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Marketing analysis</div>
                                                            </li>
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Superior Integration</div>
                                                            </li>
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Data visualization</div>
                                                            </li>
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Digital experiences</div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-6">
                                                    <div class="pl-20 res-1199-pl-0 res-575-pl-0">
                                                        <ul class="tab-list res-575-mt-0">
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Marketing analysis</div>
                                                            </li>
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Machine learning</div>
                                                            </li>
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Business intelligence</div>
                                                            </li>
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Team Performance</div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="res-991-pt-30">
                                                <img class="img-fluid" alt="tab-image" src="images/single-img-4.png" loading="lazy" />
                                            </div>
                                        </div>
                                    </div>{/* row end */}
                                </div>
                                </TabPanel>
                                <TabPanel>
                                <div className="content-inner active">
                                    <div className="row">
                                    <div className="col-lg-6">
                                            <div>
                                                <img class="img-fluid" alt="tab-image" src="images/single-img-3.png" loading="lazy" />
                                            </div>
                                        </div>
                                        <div class="col-lg-6 align-self-center">
                                            <div class="tab-content-2 res-991-mt-20">
                                                <h3 class="tab-content-h3">Our firm is an expert to creates</h3>
                                                <p>Well aware of the existing mobile app market trends to keep tabs on the evolving trend of the industry, to developing high-gradequality at the top positions! Web designing in a powerful way of just not a profession, hony. We have a tendency to beve.</p>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-6 col-md-6 col-sm-6">
                                                    <div class="list-border-left">
                                                        <ul class="tab-list">
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Marketing analysis</div>
                                                            </li>
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Superior Integration</div>
                                                            </li>
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Data visualization</div>
                                                            </li>
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Digital experiences</div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-6">
                                                    <div class="pl-20 res-1199-pl-0 res-575-pl-0">
                                                        <ul class="tab-list res-575-mt-0">
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Marketing analysis</div>
                                                            </li>
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Machine learning</div>
                                                            </li>
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Business intelligence</div>
                                                            </li>
                                                            <li class="tab-list-item">
                                                                <i class="fas fa-long-arrow-alt-up tab-list-link"></i>
                                                                <div class="tab-list-text">Team Performance</div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>{/* row end */}
                                </div>{/* content-inner */}{/* row end*/}
                                </TabPanel>
                                </FadeIn>
                            </div>
                            </Tabs>  {/* tabs end*/}
                            </div>
                        </div>
                        </div>
                    </div>
                </section>

                <section class="ttm-row ttm-bg ttm-bgcolor-gradient client-section clearfix">
                    <div class="container-fluid">
                    <Slider className="row slick_slider" {...slick_slider} slidesToShow={6}arrows={false}
                    autoplay={false} responsive= { [{ breakpoint: 1199, settings: {slidesToShow: 4,slidesToScroll: 2 }},
                    {breakpoint: 991, settings: { slidesToShow: 3, slidesToScroll: 1 }} ,
                    {breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1 }} ,
                    {breakpoint: 575, settings: { slidesToShow: 1, slidesToScroll: 1 }}] }>
                        <div className="ttm-box-col-wrapper">
                            <div className="client-box">
                                <div className="client">
                                    <div className="ttm-client">
                                        <img src="images/client/client-07.png" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="ttm-box-col-wrapper">
                            <div className="client-box">
                                <div className="client">
                                    <div className="ttm-client">
                                        <img src="images/client/client-04.png" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="ttm-box-col-wrapper">
                            <div className="client-box">
                                <div className="client">
                                    <div className="ttm-client">
                                        <img src="images/client/client-06.png" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="ttm-box-col-wrapper">
                            <div className="client-box">
                                <div className="client">
                                    <div className="ttm-client">
                                        <img src="images/client/client-04.png" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="ttm-box-col-wrapper">
                            <div className="client-box">
                                <div className="client">
                                    <div className="ttm-client">
                                        <img src="images/client/client-05.png" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="ttm-box-col-wrapper">
                            <div className="client-box">
                                <div className="client">
                                    <div className="ttm-client">
                                        <img src="images/client/client-06.png" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="ttm-box-col-wrapper">
                            <div className="client-box">
                                <div className="client">
                                    <div className="ttm-client">
                                        <img src="images/client/client-04.png" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        </Slider>
                    </div>
                </section>
                
            </div>
            )
    }
}


export default Aboutus_01;
